var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 2.5C6 2.22386 6.22385 2 6.5 2C6.77615 2 7 2.22386 7 2.5V5.5C7 5.77615 6.77615 6 6.5 6C6.22385 6 6 5.77615 6 5.5V2.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2.5C14 2.22386 14.2239 2 14.5 2C14.7761 2 15 2.22386 15 2.5V5.5C15 5.77615 14.7761 6 14.5 6C14.2239 6 14 5.77615 14 5.5V2.5Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 11.5H6V12.5H7V11.5ZM6 10.5C5.4477 10.5 5 10.9477 5 11.5V12.5C5 13.0523 5.4477 13.5 6 13.5H7C7.5523 13.5 8 13.0523 8 12.5V11.5C8 10.9477 7.5523 10.5 7 10.5H6Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 11.5H10V12.5H11V11.5ZM10 10.5C9.4477 10.5 9 10.9477 9 11.5V12.5C9 13.0523 9.4477 13.5 10 13.5H11C11.5523 13.5 12 13.0523 12 12.5V11.5C12 10.9477 11.5523 10.5 11 10.5H10Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 11.5H14V12.5H15V11.5ZM14 10.5C13.4477 10.5 13 10.9477 13 11.5V12.5C13 13.0523 13.4477 13.5 14 13.5H15C15.5523 13.5 16 13.0523 16 12.5V11.5C16 10.9477 15.5523 10.5 15 10.5H14Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 15.5H6V16.5H7V15.5ZM6 14.5C5.4477 14.5 5 14.9477 5 15.5V16.5C5 17.0523 5.4477 17.5 6 17.5H7C7.5523 17.5 8 17.0523 8 16.5V15.5C8 14.9477 7.5523 14.5 7 14.5H6Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 15.5H10V16.5H11V15.5ZM10 14.5C9.4477 14.5 9 14.9477 9 15.5V16.5C9 17.0523 9.4477 17.5 10 17.5H11C11.5523 17.5 12 17.0523 12 16.5V15.5C12 14.9477 11.5523 14.5 11 14.5H10Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 5H16.5C17.0523 5 17.5 5.4477 17.5 6V14C17.8453 14 18.1804 14.0438 18.5 14.126V6C18.5 4.89543 17.6046 4 16.5 4H4.5C3.39543 4 2.5 4.89543 2.5 6V18C2.5 19.1046 3.39543 20 4.5 20H14.0351C13.8561 19.6905 13.7174 19.3547 13.626 19H4.5C3.94772 19 3.5 18.5523 3.5 18V6C3.5 5.4477 3.94772 5 4.5 5Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 9.5H3V8.5H18V9.5Z",
    fill: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 21C19.1568 21 20.5 19.6568 20.5 18C20.5 16.3432 19.1568 15 17.5 15C15.8432 15 14.5 16.3432 14.5 18C14.5 19.6568 15.8432 21 17.5 21ZM17.5 22C19.7092 22 21.5 20.2092 21.5 18C21.5 15.7908 19.7092 14 17.5 14C15.2908 14 13.5 15.7908 13.5 18C13.5 20.2092 15.2908 22 17.5 22Z",
    fill: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 15.5898C17.7761 15.5898 18 15.8137 18 16.0898V18.2389L19.2257 19.0897C19.4526 19.2472 19.5089 19.5587 19.3514 19.7856C19.1939 20.0124 18.8824 20.0687 18.6555 19.9112L17 18.7621V16.0898C17 15.8137 17.2239 15.5898 17.5 15.5898Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/Time.20607e9ba3ba3cd82c9ca6e0a43c39f3.svg";
export { ForwardRef as ReactComponent };